import { FC } from "react";

import {
  EcommerceReassuranceBanner as UIEcommerceReassuranceBanner,
  EcommerceReassuranceBannerItem,
} from "@jti/ui/components/EcommerceReassuranceBanner";

import { dropdownMapper } from "./dropdownMapper";
import { ecommerceReassuranceBannerInputs } from "./EcommerceReassuranceBanner.builder";

export const dropdownLabels = Object.keys(dropdownMapper);

export type EcommerceReassuranceBannerProps = BuilderComponentProps<
  typeof ecommerceReassuranceBannerInputs
>;

export const EcommerceReassuranceBanner: FC<
  EcommerceReassuranceBannerProps
> = ({ items }) => {
  if (items.length === 0) return null;

  const ecommerceReassuranceBannerItems: EcommerceReassuranceBannerItem[] =
    items.map(
      (item): EcommerceReassuranceBannerItem => ({
        id: item.description,
        iconName: dropdownMapper[item.icon],
        description: item.description,
        href: item.href,
      })
    );

  return (
    <UIEcommerceReassuranceBanner items={ecommerceReassuranceBannerItems} />
  );
};
